exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".phone-update:hover {\r\n    opacity: 1;\r\n}\r\n\r\n.phone-update {\r\n    background-color: #ef3b2b;\r\n    color: #fff;\r\n    border: 1px solid #ef3b2b;\r\n    font-weight: 400;\r\n    font-size: .8rem !important;\r\n    margin-top: 0 !important;\r\n    padding: 0.5rem 1.1rem 0.6rem;\r\n    opacity: 0.8;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/phone-update/phone-update.component.css
// module id = ../../../../../src/app/profile-update/phone-update/phone-update.component.css
// module chunks = main